/**
 * welcome.tsx — Welcome-Route (welcome.html)
 *
 * Bislang gebaut aber unverdrahtet (Foundation-Bericht): Route fehlte, Nav-Ziel
 * lief ins Leere. Eigenstaendige Route wie login.tsx/register.tsx (kein
 * `_auth`-Layout — die Seite zeigt bewusst keine Sidebar/Topbar, siehe
 * welcome.html), aber mit umgekehrtem Auth-Guard: unauthentifiziert -> /login.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '../stores/authStore'
import { WelcomePage } from '../features/welcome/WelcomePage'

export const Route = createFileRoute('/welcome')({
  beforeLoad: () => {
    if (!useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
  component: WelcomePage,
})
